import ConfigurablePosition from './_configurable-position.js'
import ConfigurableBackground from './_configurable-background.js'

export default {
  name: 'Overlay',
  values: {
    mountOnInit: false,
    unmountOnHide: true,
    mountContainerOnShow: false,
    mountChildrenOnInit: true,
    resetScroll: false,
    disableBodyScrolling: true,
    rootElementId: undefined,
    style: {
      container: {
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: undefined,
        zIndex: 1000,
        $mixin: [
          {
            configSet: ConfigurablePosition,
          },
        ],
      },
      overlay: {
        animationDuration: 0.2,
        style: {
          $mixin: [
            {
              configSet: ConfigurableBackground,
            },
          ],
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
